import { useState } from 'react';
import { useQuery } from '@apollo/client';
import BOARD_QUERY, { IDesignerBoard } from '@components/pages/DesignerProfile/graphql/designer-boards.graphql';

const pageSize = 6;

interface IUseBoardsProps {
  designerId: string;
  initialBoards: IDesignerBoard[];
}

interface UseBoardsReturn {
  loading: boolean;
  fetchMore: () => void;
  boards: IDesignerBoard[];
  exhausted: boolean;
}

const useBoards = ({
  designerId,
  initialBoards
}: IUseBoardsProps): UseBoardsReturn => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [boards, setBoards] = useState<IDesignerBoard[]>(initialBoards);
  const [exhausted, setExhausted] = useState<boolean>(
    initialBoards.length !== 6
  );
  const {
    loading,
    fetchMore,
  } = useQuery(BOARD_QUERY, {
    variables: {
      pageNumber,
      designerId,
      pageSize,
      includeHidden: false
    }
  });

  const fetchMoreBoards = () => {
    const newPageNumber = pageNumber + 1;

    fetchMore({
      variables: {
        pageNumber: newPageNumber
      },
      updateQuery: (p, { fetchMoreResult }) => {
        const { designerPublicBoards } = fetchMoreResult;

        if (isExhausted(newPageNumber, designerPublicBoards)) {
          setExhausted(true);
        }

        setBoards(
          boards.concat(designerPublicBoards.items)
        );
      }
    });

    setPageNumber(newPageNumber);
  };

  return {
    loading, fetchMore: fetchMoreBoards, boards, exhausted
  };
};

function isExhausted(
  newPageNumber: number,
  designerPublicBoards: any
): boolean {
  return (pageSize * newPageNumber) > designerPublicBoards.itemCount;
}

export default useBoards;
